import { Injectable } from '@angular/core';
import { LoadOptions } from 'devextreme/common/data';
import { ReportingApiService } from './reporting-api.service';

export interface OverrideOption {
  name: string;
  value: string;
}

export interface OverrideOptionsResponse {
  data?: OverrideOption[];
  options?: OverrideOption[];
  totalCount?: number;
}

@Injectable()
export class OverrideOptionsService {
  private readonly basePath = '/api/override/options';

  constructor(private readonly reportingApiService: ReportingApiService) {}

  getProducts(loadOptions: LoadOptions | Record<string, unknown> | null | undefined): Promise<OverrideOptionsResponse> {
    return this.getList('products', loadOptions);
  }

  getCarriers(loadOptions: LoadOptions | Record<string, unknown> | null | undefined): Promise<OverrideOptionsResponse> {
    return this.getList('carriers', loadOptions);
  }

  getAgencies(loadOptions: LoadOptions | Record<string, unknown> | null | undefined): Promise<OverrideOptionsResponse> {
    return this.getList('agencies', loadOptions);
  }

  private getList(
    optionType: 'products' | 'carriers' | 'agencies',
    loadOptions: LoadOptions | Record<string, unknown> | null | undefined,
  ): Promise<OverrideOptionsResponse> {
    return this.reportingApiService.request<OverrideOptionsResponse>(`${this.basePath}/${optionType}/get-list`, {
      method: 'POST',
      body: this.normalizeLoadOptions(loadOptions),
    });
  }

  private normalizeLoadOptions(
    loadOptions: LoadOptions | Record<string, unknown> | null | undefined,
  ): Record<string, unknown> {
    if (!loadOptions || typeof loadOptions !== 'object') {
      return {
        skip: 0,
        requireTotalCount: false,
        sort: [],
        filter: [],
      };
    }

    return Object.entries(loadOptions as Record<string, unknown>).reduce<Record<string, unknown>>(
      (result, [key, value]) => {
        if (value !== undefined) {
          result[key] = value;
        }

        return result;
      },
      {},
    );
  }
}
